export default "__VITE_ASSET__YUjGpQVL__"